import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from '@core/services/theme.service';

import { AlertsComponent } from './core/components/alerts/alerts.component';
import { LoaderComponent } from './core/components/loader/loader.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, AlertsComponent, LoaderComponent],
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
    private themeService: ThemeService = inject(ThemeService);

    public ngOnInit(): void {
        this.themeService.initTheme();
    }
}
